import React from "react";
import llama from "./cutellama.jpg";


const BotAvatar = () => {
    return (
        <div>
            <img src={llama} alt="llama" />
        </div>

    )
}

export default BotAvatar;